import { render, staticRenderFns } from "./DropzoneFile.vue?vue&type=template&id=8a43dc06&scoped=true"
import script from "./DropzoneFile.vue?vue&type=script&lang=js"
export * from "./DropzoneFile.vue?vue&type=script&lang=js"
import style0 from "./DropzoneFile.vue?vue&type=style&index=0&id=8a43dc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a43dc06",
  null
  
)

export default component.exports